import { ICodWithSubtype } from '../cod-with-subtype.interface';
import { ICodInternational } from './cod-international.interface';

export interface ICodInternationalWithSubtype<T extends { issueType: string }>
    extends ICodInternational,
        ICodWithSubtype<T> {}
